// LIB
import { Dispatch } from 'redux';
import { Capacitor } from '@capacitor/core';

import { NavigationData, NavigationPlugin } from '../../../capacitor_plugins/navigation';
import { navigateToBoard } from '../../reducers/navigationActions';
import { CAPACITOR_NAVIGATION_PLUGIN } from '../../../capacitor_plugins/pluginConstants';

export const addListenerForNavigation = () => {
    return function (dispatch: Dispatch<any>) {
        if (Capacitor.isPluginAvailable(CAPACITOR_NAVIGATION_PLUGIN)) {
            NavigationPlugin.addListener('navigate', (data: NavigationData) => {
                const boardId = data.boardId;

                dispatch(navigateToBoard({ boardId }));
            });
        }
    };
};
